<!-- @format -->

<rules-tag>
<div class="contents contents-wide">
  <section class="contents_area">
    <div class="container_heading">
      <h1 class="heading-01 heading_terms">利用規約</h1>
      <ul class="breadcrumb">
        <li class="breadcrumb-item"><a href="/menu" class="home">ホーム</a></li>
        <li class="breadcrumb-item">利用規約</li>
      </ul>
    </div><!--/.container_heading-->
    

      <div class="contents_block detail">
        <rules-content-tag></rules-content-tag>
      </div><!--/.contents_block-->

      
  </section><!--/.contents_area-->
</div><!--/.contents-->


<script>
  import rulesTag from '@tags/parts/croco-id-rules.riot';
  export default {
    components: {
      "rules-content-tag": rulesTag
    }
  }
</script>
</rules-tag>
